import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthService } from './modules/auth/_services/auth.service';
// Highlight JS
import { SplashScreenModule } from './_metronic/partials/layout/splash-screen/splash-screen.module';
import { GridModule } from '@progress/kendo-angular-grid';
import { SectionService } from './modules/academic/sections/sections.service';
import { AppConstant } from './app.constant';
import { ClassService } from './modules/academic/classes/classes.service';
import { IntercepterService } from './services/core/http-interceptor';
import { SubjectService } from './modules/academic/subjects/subjects.service';
import { PrincipalService } from './modules/users/principal/principal.service';
import { AdminAndManagementService } from './modules/users/admin-and-management/admin-and-management.service';
import { FacultiesService } from './modules/users/faculties/faculties.service';
import { StudentsService } from './modules/users/students/students.service';
import { DriversService } from './modules/users/drivers/drivers.service';
import { AgentService } from './modules/users/agents/agent.service';
import { CoreHelperService } from './services/core/core-helper.service';
import { AgmCoreModule } from '@agm/core';
import { AuthenticationService } from './services/auth/auth.service';
import { ToastrModule } from 'ngx-toastr';
import { LoginService } from './modules/auth/login/login.service';
import { MailService } from './modules/mail/mail.service';
import { QuillModule } from 'ngx-quill';
import { SeminarWorkshopService } from './modules/activities/seminar-workshop/seminar-workshop.service';
import { ToasterService } from './services/toaster/toaster.service';
import { PermissionService } from './modules/permission-set/permission-set.services';
import { CurriculumService } from './modules/academic/curriculum/curriculum.services';
import { AttendanceService } from './modules/attendance/manual-attendance/manual-attendance.service';
import { LeaveManagementService } from './modules/attendance/leave-management/leave-management.service';
import { HolidayService } from './modules/attendance/holiday/holiday.service';
import { MarksService } from './modules/academic/marks/marks.service';
import { LoaderService } from './_metronic/partials/content/loader/loader.service';
import { LoaderModule } from './_metronic/partials/content/loader/loader.module';
import { ComplaintService } from './modules/other/complaints/complaints.service';
import { UserService } from './modules/users/user.service';
import { PayrollService } from './modules/payroll/payroll.service';
import { InstitutionService } from './modules/external/institute/institute.service';
import { BranchService } from './modules/external/branch/branch.service';
import { OpinionPollsService } from './modules/other/opinion-polls/opinion-polls.service';
import { ProfileCardService } from './modules/user-profile/_components/profile-card/profile-card.service';
import { TaskManagementService } from './modules/task-management/task-management.service';
import { AcademicYearService } from './modules/acadmic-year-config/acadmic-year.service';
import { PlanService } from './modules/external/plan/plan.service';
import { PurchaseService } from './modules/external/purchase/purchase.service';
import { SettingComponent } from './modules/setting/setting.component';
import { SettingService } from './modules/setting/setting.service';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SupportTicketService } from './modules/support-ticket/support-ticket.service';
import { ActivityTypeService } from './modules/activities/activity-type/activity-type.service';
import { ActivityEventsService } from './modules/activities/activities-events/activity-events.service';
import { LocationService } from './modules/academic/location/location.service';
import { BoardService } from './modules/academic/board/board.service';
import { SchoolService } from './modules/academic/schools/schools.service';
import { StudentAssessmentService } from './modules/academic/student-assessment/student-assessment.service';
import { StudentIndividualReportService } from './modules/reports/individual-student-report/student-individual-report.service';
import { FeeService } from './modules/fee/fee.service';
import { AuditLogService } from './modules/other/audit-logs/audit-log.service';
import { ReportHistoryService } from './modules/reports/report-history/report-history.service';
import { HallTicketService } from './modules/academic/hall-ticket/hall-ticket.service';
import { DocumentsService } from './modules/users/documents/documents.service';
import { SSPComponent } from './modules/ssp/ssp.component';
import { SPPAPPService } from './modules/ssp/ssp.service';
import { CommunicationComponent } from './modules/communication/communication.component';
import { ReportCardService } from './modules/academic/report-card/report-card-service';
import { AdmissionComponent } from './modules/admission/admission.component';
import { TransportationComponent } from './modules/transportation/transportation.component';
import { TransportationService } from './modules/transportation/transportation.service';
import { ViewProfileCardService } from './modules/view-profile/_components/profile-card/view-profile-card.service';

function appInitializer(authService: AuthService) {
  return () => {
    return new Promise((resolve) => {
      authService.getUserByToken().subscribe().add(resolve);
    });
  };
}

@NgModule({
  declarations: [AppComponent, SSPComponent,],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SplashScreenModule,
    TranslateModule.forRoot(),
    HttpClientModule,
    GridModule,
    ToastrModule,
    QuillModule.forRoot(),
    ToastrModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyD_s_XVK_vf2nIGBqQolQGyq-ZUxHpoXM8',
      libraries: ['places', 'geometry']
    }),
    AppRoutingModule,
    InlineSVGModule.forRoot(),
    NgbModule,
    LoaderModule,
    FlexLayoutModule,
  ],
  providers: [
    AppConstant,
    AuthenticationService,
    LoginService,
    LocationService,
    BoardService,
    SchoolService,
    SectionService,
    ClassService,
    SubjectService,
    PrincipalService,
    AdminAndManagementService,
    FacultiesService,
    StudentsService,
    DriversService,
    InstitutionService,
    PlanService,
    PurchaseService,
    AgentService,
    SeminarWorkshopService,
    CoreHelperService,
    MailService,
    BranchService,
    ToasterService,
    TaskManagementService,
    PermissionService,
    CurriculumService,
    AttendanceService,
    LeaveManagementService,
    HolidayService,
    MarksService,
    LoaderService,
    ComplaintService,
    UserService,
    PayrollService,
    ProfileCardService,
    AcademicYearService,
    SettingService,
    SupportTicketService,
    OpinionPollsService,
    ActivityTypeService,
    ActivityEventsService,
    StudentAssessmentService,
    StudentIndividualReportService,
    FeeService,
    AuditLogService,
    ReportHistoryService,
    HallTicketService,
    DocumentsService,
    SPPAPPService,
    ReportCardService,
    TransportationService,
    ViewProfileCardService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializer,
      multi: true,
      deps: [AuthService],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: IntercepterService,
      multi: true
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
